import React, { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ResendVerificationLink({ email, className = "" }) {
  const [state, setState] = useState("idle"); // idle | sending | sent

  const handleClick = async () => {
    if (!email || state === "sending") return;
    setState("sending");
    try {
      await axios.post(`${API}/auth/resend-verification`, { email });
    } catch {
      // Same UI regardless — the endpoint never reveals success/failure by design.
    }
    setState("sent");
  };

  if (state === "sent") {
    return <span className={className}>Check your email for a new link.</span>;
  }
  return (
    <button type="button" onClick={handleClick} disabled={state === "sending"} className={className}>
      {state === "sending" ? "Sending..." : "Resend verification email"}
    </button>
  );
}
